/**
 * Keep Impact cart drawer in sync after BioBlue add-to-cart + browser back (bfcache).
 * Header badge updates from cart-count; drawer line items can stay stale (especially 2nd+ adds).
 */
(function () {
  function shopifyRoot() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function getHeaderCartCount() {
    var el = document.querySelector('header cart-count');
    if (!el) return 0;
    return parseInt(el.textContent, 10) || 0;
  }

  function getDrawerLineItemCount() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.querySelector('.empty-state')) return 0;

    var lineItems = drawer.querySelectorAll('.cart-drawer__line-items line-item');
    if (!lineItems.length) return 0;

    var total = 0;
    lineItems.forEach(function (lineItem) {
      var input = lineItem.querySelector('.quantity-input[data-line-key]');
      total += input ? parseInt(input.value, 10) || 0 : 1;
    });
    return total;
  }

  function extractSectionId(drawer) {
    var section = drawer.closest('.shopify-section');
    if (!section || !section.id) return 'cart-drawer';
    return section.id.replace('shopify-section-', '');
  }

  function applyDrawerHtml(html) {
    var drawer = getCartDrawer();
    if (!drawer || !html) return false;

    var temp = document.createElement('div');
    temp.innerHTML = html;
    var updated = temp.querySelector('#cart-drawer');
    if (!updated) return false;

    drawer.replaceChildren.apply(drawer, updated.children);
    return true;
  }

  function fetchCartJs() {
    return fetch(shopifyRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function refreshCartDrawerSection() {
    var drawer = getCartDrawer();
    if (!drawer) return Promise.resolve();

    var sectionId = extractSectionId(drawer);
    return fetch(shopifyRoot() + '?section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        applyDrawerHtml(html);
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  function isDrawerStale(serverItemCount) {
    var drawer = getCartDrawer();
    if (!drawer) return false;

    if (serverItemCount <= 0) {
      return Boolean(drawer.querySelector('.cart-drawer__inner'));
    }

    if (drawer.querySelector('.empty-state')) return true;

    return getDrawerLineItemCount() !== serverItemCount;
  }

  function syncCartIfStale() {
    return fetchCartJs()
      .then(function (cart) {
        if (!isDrawerStale(cart.item_count)) return cart;
        return refreshCartDrawerSection().then(function () {
          return cart;
        });
      })
      .catch(function () {
        var headerCount = getHeaderCartCount();
        if (headerCount > 0 && isDrawerStale(headerCount)) {
          return refreshCartDrawerSection();
        }
      });
  }

  function applyFromAddResponse(addResponse) {
    if (!addResponse || !addResponse.sections) {
      return refreshCartDrawerSection();
    }

    var drawer = getCartDrawer();
    if (!drawer) return Promise.resolve();

    var sectionId = extractSectionId(drawer);
    var html =
      addResponse.sections[sectionId] || addResponse.sections['cart-drawer'];

    if (html && applyDrawerHtml(html)) {
      return Promise.resolve();
    }

    return refreshCartDrawerSection();
  }

  window.BBCartSync = {
    applyFromAddResponse: applyFromAddResponse,
    refreshDrawer: refreshCartDrawerSection,
    syncIfStale: syncCartIfStale
  };

  window.addEventListener('pageshow', function () {
    syncCartIfStale();
  });

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[aria-controls="cart-drawer"]');
      if (!trigger) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var drawer = getCartDrawer();
      syncCartIfStale().then(function () {
        if (drawer && !drawer.open) drawer.show();
      });
    },
    true
  );
})();
